import { render, staticRenderFns } from "./HomeNewsListDetail.vue?vue&type=template&id=36087336&"
import script from "./HomeNewsListDetail.vue?vue&type=script&lang=js&"
export * from "./HomeNewsListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports